import { useEffect } from "react";

import { useBrand } from "./brand";

export function useTitle(title: string | null | undefined) {
  const { productName } = useBrand();
  useEffect(() => {
    if (title) document.title = `${title} | ${productName}`;
  }, [title, productName]);
}
